import { TableKeyEnum } from '@/hooks/useTableSettingsStore';
import { createTableFiltersState } from '@/utils/table-filters';

import { ChannelFilters } from '../types';

export const useChannelFilters = createTableFiltersState<ChannelFilters>({
  tableKey: TableKeyEnum.BROADCASTERS,
});
